import axios from "axios";

// Kept outside Vuex so clearing the store cannot restore an older session id.
let sessionId = 0;

export const getSessionId = () => sessionId;

export const invalidateSession = () => {
  sessionId += 1;
};

export const ensureCurrentSession = requestSessionId => {
  if (requestSessionId !== sessionId) {
    throw new axios.CanceledError("The request belongs to a previous session.");
  }
};
